<template>
  <div class="indexBox">
    <div class="headerBox">
      <toponeHeader></toponeHeader>
    </div>
    <div class="imgIconBox">
      <div class="h1Title">公司產品</div>
      <el-carousel :interval="4000" type="card" :height="autoHeight">
        <el-carousel-item v-for="(item, index) in dataList" :key="index">
          <div class="carouselBox">
            <div class="logoBox">
              <div class="imgTitleBox">
                <div class="logoImg">
                  <img :src="item.icon" />
                </div>
                <div class="logoTitle">
                  <p>{{ item.titleName }}</p>
                  <div class="startBox">
                    <img
                      src="http://prodcdn.toponegames.cn/png/icon/star.png"
                    />
                    <img
                      src="http://prodcdn.toponegames.cn/png/icon/star.png"
                    />
                    <img
                      src="http://prodcdn.toponegames.cn/png/icon/star.png"
                    />
                    <img
                      src="http://prodcdn.toponegames.cn/png/icon/star.png"
                    />
                    <img
                      src="http://prodcdn.toponegames.cn/png/icon/onStar.png"
                    />
                  </div>
                  <span>{{ item.num }}</span>
                </div>
              </div>
              <div class="titleBox">
                {{ item.title }}
              </div>
              <div class="buttonBox">
                <div class="buttonImg">
                  <a href="https://app.mi.com/details?id=com.powerful.magnifier&ref=search">
                    <img
                      src="http://prodcdn.toponegames.cn/png/button/btn_download.png"
                    />
                  </a>
                </div>
                <div class="codeImg">
                  <img
                    src="http://prodcdn.toponegames.cn/png/icon/ic_home_code.png"
                  />
                </div>
              </div>
            </div>
            <div class="picBox">
              <img :src="item.pic" />
              <img :src="item.pic1" />
              <img :src="item.pic2" v-if="item.pic2"/>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="indexMainBox">
      <div class="h1Title">業務體系</div>
      <div class="title">
        以效率驅動的遊戲發行業務已完成技術閉環和產品閉環，正穩健輸出現金流。
      </div>
      <div class="title">
        以工具應用、互聯網娛樂為核心的創新移動互聯網業務正蓄勢待發進入快速發展階段。
      </div>
      <div class="mainImgBox">
        <div class="mainImg">
          <img src="http://prodcdn.toponegames.cn/png/img/img_home_games.png" />
          <p class="h2title">遊戲發行服務</p>
          <p class="title">
            我們致力於為中國用戶帶來高質量的遊戲,創造最極致的遊戲體驗,目前已打造數十款爆款遊戲,成為發展迅速的新銳遊戲發行商之一
          </p>
        </div>
        <div class="mainImg">
          <img src="http://prodcdn.toponegames.cn/png/img/img_home_phone.png" />
          <p class="h2title">泛娛樂應用研發</p>
          <p class="title">
            我們擁有一流的移動互聯網產品研發核心團隊,致力於為用戶提供卓越的工具應用,旗下的移動工具產品包含相冊類、清理類等多個品類
          </p>
        </div>
      </div>
    </div>
    <!-- <div class="mainBox">
      <div class="h1Title">合作伙伴</div>
      <div class="partnerBox">
        <div
          class="partnersImg"
          v-for="(item, index) in partnersList"
          :key="index"
        >
        </div>
      </div>
    </div> -->
    <div class="footerBox">
      <toponeFooter></toponeFooter>
    </div>
  </div>
</template>

<script>
import toponeFooter from "@/components/pc_topone_footer"; //引入
import toponeHeader from "@/components/pc_topone_header";
export default {
  name: "Index",
  data() {
    return {
      dataList: [
        // {
        //   title:
        //     "清理大师是一个兼具除尘排水，声波驱蚊以及手机缓存优化功能的APP。排尘除水，声波驱蚊，扫描垃圾，一键清理加速，让你的手机更畅快！清理大师是你的贴心手机管家。",
        //   titleName: "万能清理大师",
        //   pic: "http://prodcdn.toponegames.cn/png/carousel/clear/001.png",
        //   pic1: "http://prodcdn.toponegames.cn/png/carousel/clear/002.png",
        //   num: "418万下载 .32.15MB .无广告",
        //   icon: "http://prodcdn.toponegames.cn/png/carousel/clear/a2.png",
        // },
        // {
        //   title:
        //     "如果你以为这只是个填字游戏，那真的是大错特错，《成语群英传》将给你闯关、合成、收集三种游戏体验，真正的寓教于乐！在游戏中，你将穿越历史，结识各类英豪，凭借你的聪明才智在这里平步青云！是才高八斗的智者，还是胸无点墨的平庸之辈，来《成语群英传》决一上下！ ",
        //   titleName: "成语群英传",
        //   pic: "http://prodcdn.toponegames.cn/png/carousel/wifi/001.jpg",
        //   pic1: "http://prodcdn.toponegames.cn/png/carousel/wifi/002.jpg",
        //   num: "355万下载 .32.15MB .无广告",
        //   icon: "http://prodcdn.toponegames.cn/png/carousel/wifi/icon.png",
        // },
        // {
        //   title:
        //     "《赚他一个亿》是一款赚金币领红包可提现的合成休闲模拟经营应用。从基础代步车合成到豪华跑车，只要不断合成高级车辆，车库就会充满名车。而且随着车辆等级提升还可以换豪宅。应用里有丰富的日常活动和任务，轻松点一点，一步步见证你的金币增长，红包领不停，提现领现金，快行动起来吧！",
        //   titleName: "赚他一个亿",
        //   pic: "http://prodcdn.toponegames.cn/png/carousel/clearIOS/001.png",
        //   pic1: "http://prodcdn.toponegames.cn/png/carousel/clearIOS/002.png",
        //   num: "395万下载 .32.15MB .无广告",
        //   icon:
        //     "http://prodcdn.toponegames.cn/png/carousel/clearIOS/icon_512_fillet.jpg",
        // },
        // {
        //   title:
        //     "免费有趣好玩的相机APP。不仅支持童颜相机，变老相机，发型更换，年龄检测和性别转换等玩法，还能一键获取诸多的精美壁纸，提供诸多壁纸贴纸选择。快来发现展现不一样的自己吧！",
        //   titleName: "万能壁纸相机",
        //   pic: "http://prodcdn.toponegames.cn/png/carousel/camera/001.png",
        //   pic1: "http://prodcdn.toponegames.cn/png/carousel/camera/002.png",
        //   num: "256万下载 .32.15MB .无广告",
        //   icon: "http://prodcdn.toponegames.cn/png/carousel/camera/512.png",
        // },
        {
          title:
            "支持快速传输的工具APP。不仅支持离线文件传输，还支持各种功能，查看设备，查询IP地址等功能。给你的新手机和旧手机搭建快速传输的桥梁。",
          titleName: "换机大师",
          pic: "http://prodcdn.toponegames.cn/png/switchMasterPic/001.jpg",
          pic1: "http://prodcdn.toponegames.cn/png/switchMasterPic/002.jpg",
          pic2: "http://prodcdn.toponegames.cn/png/switchMasterPic/003.jpg",
          num: "256万下载 .32.15MB .无广告",
          icon: "http://prodcdn.toponegames.cn/png/switchMasterPic/icon.png",
        },
        // {
        //   title:
        //     "享阅大字版是一款专为中老年人设计的阅读神器，服务于中老年人的阅读习惯。简洁页面，清晰大字，任意放大，阅读舒适，使用便捷。",
        //   titleName: "享阅大字版",
        //   pic: "http://prodcdn.toponegames.cn/png/funReadBigPrint/001.jpg",
        //   pic1: "http://prodcdn.toponegames.cn/png/funReadBigPrint/002.jpg",
        //   num: "256万下载 .32.15MB .无广告",
        //   icon: "http://prodcdn.toponegames.cn/png/funReadBigPrint/icon.png",
        // },
        // {
        //   title:
        //     "大字版APP是一款专为中老年用户推出的浏览工具软件。优雅简洁的界面，字号随意放大，阅读浏览更舒适，使用更方便。",
        //   titleName: "大字关怀版",
        //   pic: "http://prodcdn.toponegames.cn/png/bigFontCera/001.jpg",
        //   pic1: "http://prodcdn.toponegames.cn/png/bigFontCera/002.jpg",
        //   pic2: "http://prodcdn.toponegames.cn/png/bigFontCera/003.jpg",
        //   num: "256万下载 .32.15MB .无广告",
        //   icon: "http://prodcdn.toponegames.cn/png/bigFontCera/icon.png",
        // },
        // {
        //   title:
        //     "一款快速清理手机垃圾，一键加速，手机降温，清理内存。更有效地解决手机使用过程中卡顿、发热、内存不足的问题，是一款高效的手机智能管理软件。",
        //   titleName: "万能清理大师（2022）",
        //   pic: "http://prodcdn.toponegames.cn/png/universalCleaningMaster2022/001.jpg",
        //   pic1: "http://prodcdn.toponegames.cn/png/universalCleaningMaster2022/002.jpg",
        //   pic2: "http://prodcdn.toponegames.cn/png/universalCleaningMaster2022/003.jpg",
        //   num: "256万下载 .32.15MB .无广告",
        //   icon: "http://prodcdn.toponegames.cn/png/universalCleaningMaster2022/icon.png",
        // },
        // {
        //   title:
        //     "一款专为中老年用户推出的浏览工具软件。优雅简洁的界面，字号随意放大，阅读浏览更舒适，使用更方便。",
        //   titleName: "畅读大字版Plus",
        //   pic: "http://prodcdn.toponegames.cn/png/loveLookBigFontPlus/001.jpg",
        //   pic1: "http://prodcdn.toponegames.cn/png/loveLookBigFontPlus/002.jpg",
        //   num: "256万下载 .32.15MB .无广告",
        //   icon: "http://prodcdn.toponegames.cn/png/cangDuMaxPrint/icon.png",
        // },
        // {
        //   title:
        //     "专为中老年人设计的应用，大字更清晰【天气】查看实时天气，未来天气【日历】加大号字体看日历更方便【放大镜】辅助放大字体",
        //   titleName: "必看大字版Plus",
        //   pic: "http://prodcdn.toponegames.cn/png/mustLookBigFontPlus/001.jpg",
        //   pic1: "http://prodcdn.toponegames.cn/png/mustLookBigFontPlus/002.jpg",
        //   num: "256万下载 .32.15MB .无广告",
        //   icon: "http://prodcdn.toponegames.cn/png/mustLookBigFontPlus/icon.png",
        // },
        // {
        //   title:
        //     "极速计步是一款可以帮助你健康出行、绿色生活的app。详细步数数据、里程数据，实时知道自己的运动状况；支持实时天气播报，避免打扰自己的运动计划；制作运动日程提醒表，时刻提醒自己保持健康运动。",
        //   titleName: "极速计步",
        //   pic: "http://prodcdn.toponegames.cn/png/jisujibu/001.jpg",
        //   pic1: "http://prodcdn.toponegames.cn/png/jisujibu/002.jpg",
        //   num: "256万下载 .32.15MB .无广告",
        //   icon: "http://prodcdn.toponegames.cn/png/jisujibu/icon.png",
        // },
        //{
        //  title:
        //    "一款又美又好玩的相机APP，拥有超多爆款玩法，疯狂变脸趣味无限。",
        //  titleName: "番茄相机",
        //  pic: "http://prodcdn.toponegames.cn/png/tomatoCearm/001.png",
        //  pic1: "http://prodcdn.toponegames.cn/png/tomatoCearm/002.png",
        //  num: "345万下载 .24.15MB .无广告",
        //  icon: "http://prodcdn.toponegames.cn/png/tomatoCearm/icon.png",
        //},
        //{
        //  title:
        //    "多看大字版是一款适合老年人使用的软件，让您能轻松浏览，更省心。",
        //  titleName: "多看大字版",
        //  pic: "http://prodcdn.toponegames.cn/png/universalMagnifyingGlassPro/111.png",
        //  pic1: "http://prodcdn.toponegames.cn/png/universalMagnifyingGlassPro/222.png",
        //  num: "345万下载 .24.15MB .无广告",
        //  icon: "http://prodcdn.toponegames.cn/png/universalMagnifyingGlassPro/icon.png",
        //},
        //{
        //  title:
        //    "如果你以为这只是个填字游戏，那真的是大错特错，《成语群英传》将给你闯关、合成、收集三种游戏体验，真正的寓教于乐！在游戏中，你将穿越历史，结识各类英豪，凭借你的聪明才智在这里平步青云！是才高八斗的智者，还是胸无点墨的平庸之辈，来《成语群英传》决一上下！ ",
        //  titleName: "成语群英传",
        //  pic: "http://prodcdn.toponegames.cn/png/carousel/wifi/001.jpg",
        //  pic1: "http://prodcdn.toponegames.cn/png/carousel/wifi/002.jpg",
        //  num: "355万下载 .32.15MB .无广告",
        //  icon: "http://prodcdn.toponegames.cn/png/carousel/wifi/icon.png",
        //},
        //{
        //  title:
        //    "《赚他一个亿》是一款赚金币领红包可提现的合成休闲模拟经营应用。从基础代步车合成到豪华跑车，只要不断合成高级车辆，车库就会充满名车。而且随着车辆等级提升还可以换豪宅。应用里有丰富的日常活动和任务，轻松点一点，一步步见证你的金币增长，红包领不停，提现领现金，快行动起来吧！",
        //  titleName: "赚他一个亿",
        //  pic: "http://prodcdn.toponegames.cn/png/carousel/clearIOS/001.png",
        //  pic1: "http://prodcdn.toponegames.cn/png/carousel/clearIOS/002.png",
        //  num: "395万下载 .32.15MB .无广告",
        //  icon: "http://prodcdn.toponegames.cn/png/carousel/clearIOS/icon_512_fillet.jpg",
        //},
        //{
        //  title:
        //    "起始设置一定数量和颜色的星星，玩家每次消除后，星星会自动由下向上上升一行，当星星上升至最顶端时，游戏结束。",
        //  titleName: "欢乐消星星",
        //  pic: "http://prodcdn.toponegames.cn/png/img/happyStart1.jpg",
        //  pic1: "http://prodcdn.toponegames.cn/png/img/happyStart2.jpg",
        //  num: "256万下载 .32.15MB .无广告",
        //  icon: "http://prodcdn.toponegames.cn/png/img/happyStartIcon.png",
        //},
      ],
      currentIndex: 0, //默认显示图片
      timer: null, //定时器
      partnersList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
    };
  },
  methods: {
    gotoPage(index) {
      this.currentIndex = index;
    },
    runInv() {
      this.timer = setInterval(() => {
        this.gotoPage(this.nextIndex);
      }, 2000);
    },
  },
  mounted() {
    this.runInv();
  },
  computed: {
    //这里设置banner 是在900像素下高度为200px，我的banner图格式为1920X900像素
    autoHeight() {
      let _w =
        document.documentElement.clientWidth || document.body.clientWidth;
      return (_w * 120) / 450 + "px";
    },
    //上一张
    prevIndex() {
      if (this.currentIndex == 0) {
        return this.dataList.length - 1;
      } else {
        return this.currentIndex - 1;
      }
    },
    //下一张
    nextIndex() {
      if (this.currentIndex == this.dataList.length - 1) {
        return 0;
      } else {
        return this.currentIndex + 1;
      }
    },
  },
  components: {
    toponeFooter,
    toponeHeader,
  },
};
</script>
<style >
.el-carousel__mask {
  width: 100%;
  background-color: #fff;
  opacity: 0.7 !important;
  -webkit-transition: 0.2s;
  transition: 0.2s;
}
</style>
<style lang="scss" scoped>
.indexBox {
  .headerBox {
  }
  .imgIconBox {
    padding: 50px 0;
    background-color: #f3f9ff;
    .h1Title {
      padding-bottom: 60px;
      font-size: 30px;
      font-weight: bold;
      letter-spacing: 0px;
      color: #000000;
      text-align: center;
    }
    .carouselBox {
      display: flex;
      justify-content: space-between;
      padding: 4%;
      // padding: 60px 40px 60px 40px;
      //height: 90%;
      height: 80%;
      .logoBox {
        width: 45%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .imgTitleBox {
          display: flex;
          // margin-bottom: 20px;
          .logoImg {
            height: 114px;
            width: 114px;
            margin-right: 20px;
            img {
              width: 100%;
              height: 100%;
              margin-right: 5%;
            }
          }
          .logoTitle {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .startBox {
              display: flex;
              img {
                width: 20px;
                height: 20px;
                margin-right: 5px;
              }
            }
            p {
              font-size: 150%;
              font-weight: bold;
            }
            span {
              font-size: 60%;
              color: rgba(0, 0, 0, 0.6);
              line-height: 24px;
            }
          }
        }
        .titleBox {
          color: rgba(0, 0, 0, 0.6);
          line-height: 24px;
          // font-size: 18px;
          font-size: 100%;
          // margin-bottom: 30px;
        }
        .buttonBox {
          display: flex;
          align-items: center;
          .buttonImg {
            width: 60%;
            margin-right: 10%;
            img {
              width: 100%;
            }
          }
          .codeImg {
            width: 15%;
            img {
              width: 100%;
            }
          }
        }
      }
      .picBox {
        width: 80%;
        display: flex;
        img {
          width: 30%;
          height: 90%;
          margin: 0 2%;
        }
      }
    }
  }
  .indexMainBox {
    // height: 670px;
    background-image: url("http://prodcdn.toponegames.cn/png/hkfeiliangWebPics/img_home_.png");
    background-size: cover;
    background-position: center;
    -webkit-font-smoothing: antialiased; // 这个属性可以使页面上的字体抗锯齿,使用后字体看起来会更清晰舒服
    text-align: center;
    .h1Title {
      padding-top: 120px;
      padding-bottom: 20px;
      font-size: 30px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #ffff;
    }
    .title {
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 24px;
      letter-spacing: 0px;
      color: rgba(255, 255, 255, 0.8);
    }
    .mainImgBox {
      padding-top: 60px;
      padding-bottom: 110px;
      display: flex;
      align-items: center;
      justify-content: center;
      .mainImg {
        background-color: #fff;
        margin: 0 10px;
        padding: 30px 40px;
        .h2title {
          font-size: 18px;
          font-weight: bold;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #47495a;
          margin-bottom: 10px;
          margin-top: 20px;
        }
        .title {
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 24px;
          letter-spacing: 0px;
          color: #6a7c92;
        }
        p {
          width: 280px;
        }
      }
    }
  }
  .mainBox {
    // height: 510px;
    background-color: #ffffff;
    text-align: center;
    padding: 120px 0 80px 0;
    .h1Title {
      padding-bottom: 45px;
      font-size: 30px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #000000;
    }
    .partnerBox {
      display: flex;
      flex-flow: wrap;
      // padding: 0 140px;
      align-items: center;
      justify-content: flex-start;
      place-content: center;
      .partnersImg {
        width: 180px;
        height: 87px;
        background-color: #f7f7f7;
        border-radius: 8px;
        margin: 10px;
      }
    }
  }
  .footerBox {
  }
}
.el-carousel__item h3 {
  color: #000;
  font-size: 14px;
  opacity: 0.6;
  line-height: 200px;
  margin: 0;
}
.el-carousel__item {
  box-shadow: 0px 12px 40px 0px #dee9ff;
}

.el-carousel__item:nth-child(2n) {
  background-color: #fff;
}
.el-carousel__item:nth-child(2n + 1) {
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/pc/index.vue